// export const urlData = "https://www.hosindia.com/api";
// export const urlData = "https://laxmihos.com/api";
export const urlData = process.env.REACT_APP_API_URL;
// export const imgUrlData = "https://laxmihos.com/api/public/";
// export const imgUrlData = "https://laxmihos.com/api/public/";
export const imgUrlData = process.env.REACT_APP_AZURE_OBJECT_URL + "public/";
